import styled from 'styled-components';

import {ms} from '../../../../styles/normalizeSize';
import {Button} from '../../../../uikit/Button';
import {View} from '../../../../uikit/View';
import {Camera} from '../../components/Camera';

export const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const SCamera = styled(Camera)`
  flex: 1;
  border-radius: ${ms(10)};
  overflow: hidden;
`;

export {SCamera as Camera};

export const OptionsContainer = styled(View)`
  margin: ${ms(24)} 0;
  flex-direction: row;
`;

export const OptionsSeparator = styled(View)`
  width: ${ms(20)};
`;

export const ActionButton = styled(Button).attrs({scheme: 'primary'})``;
